import { render, staticRenderFns } from "./dashboard-charts.vue?vue&type=template&id=36b31c09"
import script from "./dashboard-charts.vue?vue&type=script&lang=js"
export * from "./dashboard-charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports